/** Stable analytics IDs; keep these even if the reminder's copy changes. */
export const SESSION_REMINDERS = {
  'wondr-app-reminder': { name: 'Wondr', category: 'tag' },
  'glp1-reminder': { name: 'GLP-1 template', category: 'tag' },
  'pre-glp1-reminder': { name: 'Pre-GLP-1 template', category: 'tag' },
  'fertility-reminder': { name: 'Fertility template', category: 'tag' },
  'pregnancy-or-post-natal-reminder': {
    name: 'Pregnancy or postpartum template',
    category: 'tag',
  },
  'heart-health-reminder': { name: 'Heart health template', category: 'tag' },
  'diabetes-or-prediabetes-reminder': {
    name: 'Diabetes or prediabetes template',
    category: 'tag',
  },
  'factor-patient-reminders': { name: 'Factor', category: 'tag' },
  'mayo-patient-reminders': { name: 'Mayo', category: 'tag' },
  'signos-patient-reminders': { name: 'Signos', category: 'tag' },
  'mbiota-patient-reminders': { name: 'mBIOTA', category: 'tag' },
  'lingo-patient-reminders': { name: 'Lingo', category: 'tag' },
  'walmart-patient-reminders': { name: 'Walmart', category: 'tag' },
  'zocdoc-patient-reminder': { name: 'Zocdoc GLP-1', category: 'tag' },
  'aetna-session-limit-reminder': {
    name: 'Aetna session limit',
    category: 'payer',
  },
} as const;

export type SessionReminderId = keyof typeof SESSION_REMINDERS;
